export default __webpack_public_path__ + "static/media/img-stake-stacking-mobile.8fe368ff.png";